import React from 'react'
import ScheduleTimelineItem from './ScheduleTimelineItem'

class ScheduleTimelineItems extends React.Component {
   manageTimelineData(data) {
      this.props.manageTimelineData(data);
      if (data.checked) {
        return this.props.handleItemClick('', '');
      }
    }
    completedTaskClass() {
      if (this.props.timeline_events.uncompleted_items.length > 0) {
        return 'margin-required';
      } else {
        return '';
      }
    }

    checkHidden(timeline_item){
      return timeline_item.visible || this.props.show_hidden_tasks;
    }

    checkEventFilter(timeline_item) {
      const event_type = timeline_item.event_type.trim().length ?
        timeline_item.event_type.parameterize('_')
      :
        'information_only';
      return this.props[`show_${event_type}_tasks`] || (this.props[`show_${event_type}_tasks`] === undefined);
    }

    renderScheduleTimelineItem (timeline_item, className) {
      if (this.checkHidden(timeline_item) && this.checkEventFilter(timeline_item)){
        return (
          <ScheduleTimelineItem
            data={timeline_item}
            key={timeline_item.id}
            class_name={className}
            onTimelineCheck={this.manageTimelineData.bind(this)}
            handleItemClick={this.props.handleItemClick}
            display_modal={this.props.display_modal}
            onHelpfulCheck={this.props.onHelpfulCheck}
            handleJustLookingClick={this.props.handleJustLookingClick}
            handleCustomTaskDelete={this.props.handleCustomTaskDelete}
            handleCustomTaskChange={this.props.handleCustomTaskChange}
            handleCustomTaskClick={this.props.handleCustomTaskClick}
            custom_task_modal={this.props.custom_task_modal}
            isLeavePlanPartner={this.props.isLeavePlanPartner}
            disabledTaskEmailNotifications={this.props.disabledTaskEmailNotifications}
          />
          )
      } else {
        return null
      }
    }

    renderIncompletedItems () {
      return this.props.timeline_events.uncompleted_items.map((timeline_item) => this.renderScheduleTimelineItem(timeline_item, 'uncompleted'))
    }

    renderCompletedItems () {
      return (
        <div className='completed-items'>
          <div className={`completed-tasks ${this.completedTaskClass()}`}>
            Completed Tasks
          </div>
          {this.props.timeline_events.completed_items.map((timeline_item) => this.renderScheduleTimelineItem(timeline_item, 'completed'))}
        </div>
      )
    }

    render() {
      return (
        <div className='timeline-items'>
          {this.renderIncompletedItems()}
          {this.props.timeline_events.completed_items.length > 0 && this.renderCompletedItems()}
        </div>
      );
    }

}

export default ScheduleTimelineItems
